import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles<Theme>((theme) => ({
  text: {
    '& > b': {
      fontWeight: "bold",
    },
  },
}));
